/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';

import ACCOUNT_NAVIGATION_QUERY from 'user/queries/AccountNavigationQuery.gql';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import Greeting from 'components/Greeting';
import Link from 'components/Link';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';
import UserNavigationMenu from 'components/UserNavigationMenu';

import type { AccountNavigationQuery } from 'user/queries/__generated__/AccountNavigationQuery';

import './styles/AccountNavigation.scss';

type Props = {
  data: ReactApolloData<AccountNavigationQuery>,
};

function AccountNavigation(props: Props) {
  const {
    data: { user },
  } = props;

  const canAddProfilePicture = CurrentUser.getUser().canAddProfilePicture();
  const name = user ? user.display_name : '_ _ _';

  return (
    <div className="AccountNavigation">
      {canAddProfilePicture && (
        <Link to="/settings/profile">
          <UserAvatar className="AccountNavigation-avatar" user={user} color="white" size="large" />
        </Link>
      )}
      <div className="AccountNavigation-content">
        <Text color="thunder" size="xsmall">
          <Greeting />,
        </Text>
        <UserNavigationMenu showRCE={user ? user.is_rce : false}>
          <Link color="inherit" className="AccountNavigation-content-user">
            <Text truncate size="large">
              {name}
            </Text>
            <Glyph name="chevron-down" size="xsmall" />
          </Link>
        </UserNavigationMenu>
      </div>
    </div>
  );
}

const withUser = graphql(ACCOUNT_NAVIGATION_QUERY);

export { AccountNavigation };
export default withUser(AccountNavigation);
